import type { ProductData } from "~/models/ProductData";
import type { MMDFormValues } from "../MMDDialog";
import { useSelector } from "react-redux";
import { selectSearchQuery } from "~/Search/redux/searchSelectors";

export const useSrpCmnLogic = (product: ProductData): Partial<MMDFormValues> => {
  const searchQuery = useSelector(selectSearchQuery);
  if (product.cmnSearchMatched) {
    return {
      customerMaterialNumbers: [searchQuery],
      filterOrder: ["customerMaterialNumbers"],
    };
  }
  return {};
};
